<fgb-account-layout titleKey="points.management.page.title" titleDefault="Send Points">
  <fgb-account-panel titleKey="points.management.page.title" titleDefault="Send Points">
    <fgb-points-transfer></fgb-points-transfer>
  </fgb-account-panel>
</fgb-account-layout>
